/*************    |     START MB-REDESIGN JS CODE®       |   *************/
/* mb-image-with-text-slider */
function mbslidercontent() {
  $('.mb-image-with-text-slider-content').slick({
    dots: true,
    customPaging: function (slider, i) {
      var thumb = $(slider.$slides[i]).data();
      return '<a class="dot">' + (i + 1) + '</a>';
    },
    arrows: true,
    autoplay: false,
    adaptiveHeight: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: "<button class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_1.svg?v=1675657617' /></button>",
    nextArrow: "<button class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_2.svg?v=1675658002' /></button>",
    responsive: [{
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  });
}
setTimeout(function () {
  mbslidercontent();
}, 2000);

/* mb-new-video-carousel */
var vimeo_videos = document.querySelectorAll('.video-section__poster');
Array.from(vimeo_videos).forEach(vimeo_video => {
  vimeo_video.addEventListener('click', function (event) {
    setTimeout(function () {
      var player = new Vimeo.Player(event.target.parentElement.parentElement.querySelector("iframe"));
      player.play();
      player.on('play', function (data) {
        $('#mb-videos-carousel-section .slick-prev').addClass('disabled-button');
        $('#mb-videos-carousel-section .slick-next').addClass('disabled-button');
      });
      player.on('ended', function (data) {
        $('#mb-videos-carousel-section .slick-prev').removeClass('disabled-button');
        $('#mb-videos-carousel-section .slick-next').removeClass('disabled-button');
      });
      player.on('pause', function (data) {
        $('#mb-videos-carousel-section .slick-prev').removeClass('disabled-button');
        $('#mb-videos-carousel-section .slick-next').removeClass('disabled-button');
      });
    }, 1000);
  });
});


$('.mb-videos-slick-block').slick({
  dots: false,
  arrows: true,
  autoplay: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  swipe: false,
  prevArrow: "<button class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_1.svg?v=1675657617' /></button>",
  nextArrow: "<button class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_2.svg?v=1675658002' /></button>",
  responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true
      }
    },
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false
      }
    }
  ]
});
/*************    |     END MB-REDESIGN JS CODE®       |   *************/

(function () {
  var customlogoslider = function () {
    $('.column-slider-block').slick({
      dots: false,
      arrows: true,
      autoplay: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: "<button class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_1.svg?v=1675657617' /></button>",
      nextArrow: "<button class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_2.svg?v=1675658002' /></button>",
      responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  };
  customlogoslider();

  $(document).on('shopify:section:load', function (event) {
    customlogoslider();

  });
}());


(function () {
  var mbmulticolumncustomlogoslider = function () {
    $('.mb-multicolumn-column-slider-block').slick({
      dots: false,
      arrows: true,
      autoplay: true,
      infinite: true,
      speed: 400,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: "<button class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_1.svg?v=1675657617' /></button>",
      nextArrow: "<button class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_2.svg?v=1675658002' /></button>",
      responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  };
  mbmulticolumncustomlogoslider();

  $(document).on('shopify:section:load', function (event) {
    mbmulticolumncustomlogoslider();

  });
}());


$(window).scroll(function () {
  // video to play when is on viewport 
  var elementTop, elementBottom, viewportTop, viewportBottom;
  if ($('#compare-dome-video-section video').length) {
    elementTop = $('#compare-dome-video-section video').offset().top;
    elementBottom = elementTop + $('#compare-dome-video-section video').outerHeight();
    viewportTop = $(window).scrollTop();
    viewportBottom = viewportTop + $(window).height();

    if (elementBottom > viewportTop && elementTop < viewportBottom) {
      $('#compare-dome-video-section video')[0].play();
    } else {
      $('#compare-dome-video-section video')[0].pause();
    }
  }
});

// Slider Custom collection section
$('.has-slider').owlCarousel({
  loop: true,
  autoplay: false,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  dots: false,
  margin: 5,
  responsiveBaseElement: 'body',
  responsive: {
    0: {
      items: 2.3,
    },
    480: {
      items: 2.3,
    },
    768: {
      items: 3,
    },
    1220: {
      items: 4,
    },
  },
});
$(document).ready(function () {
  $(".owl-prev").html("<img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_1.svg?v=1675657617' />");
  $(".owl-next").html("<img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_2.svg?v=1675658002' />");
})

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// accordian js 
$(document).ready(function () {
  var accordionContent = $('.faq_answer');
  var accordianHeading = $('.faq_question');
  accordianHeading.click(function () {
    accordianHeading.removeClass("open");
    var isOpen = $(this).next().is(":visible");
    accordionContent.slideUp(500);
    if (!isOpen) {
      $(this).nextUntil(accordianHeading).slideDown(500);
      $(this).addClass("open");
    }
  });

function getSlickSettings()
{
$('.card__media').each(( index, ele )=> {
    const cardMediaHeight = $(ele).height();
    $(ele).find('.variant-images img').css({'max-height': cardMediaHeight + 'px'});
});

  return {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1500,
    arrows: true
  }
}

$('.card__media .variant-images:first-of-type').slick(getSlickSettings());

$(document).on('click','.custom-swatch-single-opt .product_tile_color_holder ul li label',function(e) 
{
  $('.custom-swatch-single-opt .product_tile_color_holder ul li label').removeClass('label-active');
  $(this).addClass('label-active');
  var $title_selector = $(this).parents('.product-card-wrapper').find('.card__information .card__heading.h5 a');
  var $image_selector = $(this).parents('.product-card-wrapper').find('.card__media a img');
  var $url_selector = $(this).parents('.product-card-wrapper').find('.card--media a');
  var $submit_btn_selector = $(this).parents('.product-card-wrapper').find('.quick-add-atc__submit');
  var $submit_btn_span_selector = $(this).parents('.product-card-wrapper').find('.quick-add-atc__submit span');
  var $form_input_selector = $(this).parents('.product-card-wrapper').find('product-form input[name="id"]');
  var $form_variant_price_selector = $(this).parents('.product-card-wrapper').find('.price__container .price__regular .price-item.price-item--regular');
  var $form_variant_sale_price_selector = $(this).parents('.product-card-wrapper').find('.price__container .price__sale .price-item.price-item--sale');
  var $promo_price = $(this).attr('data-promo-price');
  $(this).parents('.product-card-wrapper').find('.promo span').text($promo_price);
  var original_image = $(this).attr('data-original-image');
  $image_selector.attr({
    srcset: original_image,
    src: original_image
  });

  var variant_title = $(this).attr('data-variant-title');
  $title_selector.text(variant_title);

  var variant_id = $(this).attr('data-variant-id');
  $form_input_selector.val(variant_id).trigger('change');

  var variant_price = $(this).attr('data-variant-price');
  $form_variant_price_selector.text(variant_price);
  if($form_variant_sale_price_selector.length > 0){
    $form_variant_sale_price_selector.text(variant_price);
  }

  var variant_url = $(this).attr('data-variant-url');
  $url_selector.attr('href', variant_url);

  var variant_availability = $(this).attr('data-variant-available');
  if (variant_availability === false || variant_availability == "false") {
    $submit_btn_selector.prop('disabled', true);
    $submit_btn_span_selector.text('Sold Out');
  } else {
    $submit_btn_selector.prop('disabled', false);
    $submit_btn_span_selector.text('Add to cart');
  }

  const color = $(this).data('option-value').toLowerCase().replace(/[()]/g, '').replace(/[^\w]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  if(color !== null && color !== undefined )
  {
    const $gridItem = $(this).closest('li.grid__item');
    if($gridItem !== null && $gridItem !== undefined )
    {
      $gridItem.find('.card__media .variant-images.slick-initialized').slick('unslick');
      $gridItem.find(`.card__media .variant-images-${color}`).slick(getSlickSettings());
    }
  }
});

  $(document).on('click','.custom-swatch-single-opt .product_tile_size_holder ul li label',function(e) {
    $(this).parents('.product-card-wrapper').find('.custom-swatch-single-opt .product_tile_size_holder ul li label').removeClass('label-active');
    $(this).addClass('label-active');
    var $url_selector = $(this).parents('.product-card-wrapper').find('.card--media a');
    var $submit_btn_selector = $(this).parents('.product-card-wrapper').find('.quick-add-atc__submit');
    var $submit_btn_span_selector = $(this).parents('.product-card-wrapper').find('.quick-add-atc__submit span');
    var $form_input_selector = $(this).parents('.product-card-wrapper').find('product-form input[name="id"]');
    var $form_variant_price_selector = $(this).parents('.product-card-wrapper').find('.price__container .price__regular .price-item.price-item--regular');
    var $form_variant_sale_price_selector = $(this).parents('.product-card-wrapper').find('.price__container .price__sale .price-item.price-item--sale');
    var $promo_price = $(this).attr('data-promo-price');
    $(this).parents('.product-card-wrapper').find('.promo span').text($promo_price);


    var variant_id = $(this).attr('data-variant-id');
    $form_input_selector.val(variant_id).trigger('change');

    var variant_price = $(this).attr('data-variant-price');
    $form_variant_price_selector.text(variant_price);
    if($form_variant_sale_price_selector.length > 0){
      $form_variant_sale_price_selector.text(variant_price);
    }

    var variant_url = $(this).attr('data-variant-url');
    $url_selector.attr('href', variant_url);

    var variant_availability = $(this).attr('data-variant-available');
    if (variant_availability === false || variant_availability == "false") {
      $submit_btn_selector.prop('disabled', true);
      $submit_btn_span_selector.text('Sold Out');
    } else {
      $submit_btn_selector.prop('disabled', false);
      $submit_btn_span_selector.text('Add to cart');
    }
  });

$(document).on('click','.custom-swatch-multi-opts .product_tile_color_holder li label',function(e) {
  var $title_selector = $(this).parents('.product-card-wrapper').find('.card__information .card__heading.h5 a');
  var $image_selector = $(this).parents('.product-card-wrapper').find('.card__media a img');
  var $url_selector = $(this).parents('.product-card-wrapper').find('.card--media a');

  $(this).parents('.product-card-wrapper').find(".custom-swatch-multi-opts .product_tile_color_holder li label").removeClass("label-active");
  $(this).addClass("label-active");

  $(this).parents('.product-card-wrapper').find('.custom-swatch-multi-opts .bg-option2-edit').removeClass("unavailable");
  $(this).parents('.product-card-wrapper').find('.custom-swatch-multi-opts .bg-option2-edit.label-active').click();
  var selectedColor = $(this).attr("data-option-value");
  var _this = $(this);

  $(this).parents('.product-card-wrapper').find(".custom-swatch-multi-opts span[data-option1='" + selectedColor + "'][data-variant_availability='false']").each(function() {
    if($(this).attr('data-option3') == ''){
      var option2 = $(this).attr("data-option2");

      var sizeLabel = $(this).parents('.product-card-wrapper').find(".custom-swatch-multi-opts .bg-option2-edit[data-option-value='" + option2 + "']");
      sizeLabel.addClass("unavailable");
    }
  });
  if(_this.closest('.custom-swatch-multi-opts').find('.product_tile_option3_holder ul li').length > 0){
    _this.closest('.custom-swatch-multi-opts').find('.product_tile_option2_holder ul li').each(function() {
      var exist = 0;
      var option2_val = $(this).find('label').attr('data-option-value');
      $(this).parents('.product-card-wrapper').find(".custom-swatch-multi-opts span[data-option1='" + selectedColor + "'][data-option2='" + option2_val + "'][data-variant_availability='false']").each(function() {
          var data_option3_val = $(this).data('option3')
          _this.closest('.custom-swatch-multi-opts').find('.product_tile_option3_holder ul li').each(function() {
              var option3_val = $(this).find('label').attr('data-option-value');
            if(option3_val == data_option3_val){
              exist++;
            }
          })
        })
      if(_this.closest('.custom-swatch-multi-opts').find('.product_tile_option3_holder ul li').length == exist){
          var sizeLabel = $(this).parents('.product-card-wrapper').find(".custom-swatch-multi-opts .bg-option2-edit[data-option-value='" + option2_val + "']");
          sizeLabel.addClass("unavailable");
      }
    })
  }
  

  var variant_title = $(this).attr('data-variant-title');
  $title_selector.text(variant_title);

  var variant_url = $(this).attr('data-variant-url');
  $url_selector.attr('href', variant_url);

  var original_image = $(this).attr('data-original-image');
  $image_selector.attr({
    srcset: original_image,
    src: original_image
  });

  const color = $(this).data('option-value').toLowerCase().replace(/[()]/g, '').replace(/[^\w]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  if(color !== null && color !== undefined )
  {
    const $gridItem = $(this).closest('li.grid__item');
    if($gridItem !== null && $gridItem !== undefined )
    {
      $gridItem.find('.card__media .variant-images.slick-initialized').slick('unslick');
      $gridItem.find(`.card__media .variant-images-${color}`).slick(getSlickSettings());
    }
  }
});

  $(document).on('click','.custom-swatch-multi-opts .product_tile_option2_holder li label',function(e) {
    console.log('here');
    $(this).parents('.product-card-wrapper').find(".custom-swatch-multi-opts .product_tile_option2_holder li label").removeClass("label-active");
    $(this).addClass("label-active");

    var $url_selector = $(this).parents('.product-card-wrapper').find('.card--media a');
    var $submit_btn_selector = $(this).parents('.product-card-wrapper').find('.quick-add-atc__submit');
    var $submit_btn_span_selector = $(this).parents('.product-card-wrapper').find('.quick-add-atc__submit span');
    var $form_input_selector = $(this).parents('.product-card-wrapper').find('product-form input[name="id"]');
    var $form_variant_price_selector = $(this).parents('.product-card-wrapper').find('.price__container .price__regular .price-item.price-item--regular');

    const selectedOption2 = $(this).attr("data-option-value");
    const selectedOption1 = $(this).parents('.product-card-wrapper').find(".product_tile_option1_holder .bg-option1-edit.label-active").attr("data-option-value");
    const selectedColor = $(this).parents('.product-card-wrapper').find(".product_tile_color_holder .bg-edit.label-active").attr("data-option-value");
    const selectedOption3 = $(this).parents('.product-card-wrapper').find(".product_tile_option3_holder .bg-option3-edit.label-active").attr("data-option-value");
    var variantselector = $(this).parents('.product-card-wrapper').find(`[data-option1="${selectedOption1}"][data-option2="${selectedOption2}"]`);
    if(variantselector.length > 0){
      var promo_price = variantselector.attr('data-promo-price');
      var selected_var_price = variantselector.attr('data-variant-price');
      $(this).parents('.product-card-wrapper').find('.price__regular .price-item--regular').text(selected_var_price);
      $(this).parents('.product-card-wrapper').find('.promo span').text(promo_price);
    }
    var variantElement = $(this).parents('.product-card-wrapper').find(`[data-option1="${selectedColor}"][data-option2="${selectedOption2}"]`);

    if(typeof selectedOption3 != 'undefined') {
      variantElement = $(this).parents('.product-card-wrapper').find(`[data-option1="${selectedColor}"][data-option2="${selectedOption2}"][data-option3="${selectedOption3}"]`);
      $(this).parents('.product-card-wrapper').find('.custom-swatch-multi-opts .bg-option3-edit').removeClass("unavailable");
      $(this).parents('.product-card-wrapper').find('.custom-swatch-multi-opts .bg-option3-edit.label-active').click();
      $(this).parents('.product-card-wrapper').find(".custom-swatch-multi-opts span[data-option1='" + selectedColor + "'][data-option2='" + selectedOption2 + "'][data-variant_availability='false']").each(function() {
        var option3 = $(this).attr("data-option3");

        var option3Label = $(this).parents('.product-card-wrapper').find(".custom-swatch-multi-opts .bg-option3-edit[data-option-value='" + option3 + "']");
        option3Label.addClass("unavailable");
      });
    }

    if (variantElement.length > 0) {
      var variant_id = variantElement.attr('data-variant-id');
      $form_input_selector.val(variant_id).trigger('change');
      var promo_price = variantElement.attr('data-promo-price');
      $(this).parents('.product-card-wrapper').find('.promo span').text(promo_price);
      if(!$('body').hasClass('collection')){
      $(this).parents('.product-card-wrapper').find('.promo span').text(promo_price);
      }

      var variant_price = variantElement.attr('data-variant-price');
      $form_variant_price_selector.text(variant_price);

      var variant_url = variantElement.attr('data-variant-url');
      $url_selector.attr('href', variant_url);

      var variant_availability = variantElement.attr('data-variant_availability');
      if (variant_availability === false || variant_availability == "false") {
        $submit_btn_selector.prop('disabled', true);
        $submit_btn_span_selector.text('Sold Out');
      } else {
        $submit_btn_selector.prop('disabled', false);
        $submit_btn_span_selector.text('Add to cart');
      }
    }
  });

  $(document).on('click','.custom-swatch-multi-opts .product_tile_option3_holder li label',function(e) {
    $(this).parents('.product-card-wrapper').find(".custom-swatch-multi-opts .product_tile_option3_holder li label").removeClass("label-active");
    $(this).addClass("label-active");

    // var $title_selector = $(this).parents('.product-card-wrapper').find('.card__information .card__heading.h5 a');
    var $url_selector = $(this).parents('.product-card-wrapper').find('.card--media a');
    var $submit_btn_selector = $(this).parents('.product-card-wrapper').find('.quick-add-atc__submit');
    var $submit_btn_span_selector = $(this).parents('.product-card-wrapper').find('.quick-add-atc__submit span');
    var $form_input_selector = $(this).parents('.product-card-wrapper').find('product-form input[name="id"]');
    var $form_variant_price_selector = $(this).parents('.product-card-wrapper').find('.price__container .price__regular .price-item.price-item--regular');

    const selectedOption3 = $(this).attr("data-option-value");
    const selectedColor = $(this).parents('.product-card-wrapper').find(".product_tile_color_holder .bg-edit.label-active").attr("data-option-value");
    const selectedOption2 = $(this).parents('.product-card-wrapper').find(".product_tile_option2_holder .bg-option2-edit.label-active").attr("data-option-value");

    const variantElement = $(this).parents('.product-card-wrapper').find(`[data-option1="${selectedColor}"][data-option2="${selectedOption2}"][data-option3="${selectedOption3}"]`);

    if (variantElement.length > 0) {
      var variant_id = variantElement.attr('data-variant-id');
      $form_input_selector.val(variant_id).trigger('change');

      var variant_price = variantElement.attr('data-variant-price');
      $form_variant_price_selector.text(variant_price);

      var variant_url = variantElement.attr('data-variant-url');
      $url_selector.attr('href', variant_url);

      var variant_availability = variantElement.attr('data-variant_availability');
      if (variant_availability === false || variant_availability == "false") {
        $submit_btn_selector.prop('disabled', true);
        $submit_btn_span_selector.text('Sold Out');
      } else {
        $submit_btn_selector.prop('disabled', false);
        $submit_btn_span_selector.text('Add to cart');
      }
    }
  });

  $('.product_tile_color_holder .label-active').each(function() {
    var productTitle = $(this).parents('.product-card-wrapper').find('.card__information .card__heading.h5 a').text();
    $(this).click();
    $(this).parents('.product-card-wrapper').find('.card__information .card__heading.h5 a').text(productTitle);
  });

  $('.product_tile_color_holder').each(function() {
    var container = $(this);
    var list = container.find('ul');

    var maxScroll = list[0].scrollWidth - list[0].clientWidth;
    if (maxScroll > 0) {
      container.find(".scroll-button").show();
    }
  });

  $('.custom-swatch-multi-opts .scroll-button').on('click', function() {
    var container = $(this).closest('.product_tile_color_holder');
    var list = container.find('ul');
    var scrollAmount = 100;
    var direction = $(this).hasClass('scroll-left') ? -1 : 1; // 1 for right, -1 for left

    var currentPosition = list.scrollLeft();
    var newPosition = currentPosition + scrollAmount * direction;

    list.animate({ scrollLeft: newPosition }, 500);

    // Disable or enable the buttons based on scroll position
    var maxScroll = list[0].scrollWidth - list[0].clientWidth;

    container.find('.scroll-button').prop('disabled', false); // Reset button state
    if (newPosition <= 0) {
      container.find('.scroll-button.scroll-left').prop('disabled', true);
      container.find('.scroll-button.scroll-right').prop('disabled', false);
    } else if (newPosition >= maxScroll) {
      container.find('.scroll-button.scroll-left').prop('disabled', false);
      container.find('.scroll-button.scroll-right').prop('disabled', true);
    }
  });
});

jQuery(document).ready(function () {
  function wcRenameSize() {
    let found = false;
    let count = 0;
    let wcInterval;

    function wcRenameSizeInterval() {
      if (!found) {
        if (jQuery('ul.grid li.grid__item .swatches ul.swatch-view li.swatch-view-item span').length) {
          clearInterval(wcInterval);
          found = true;
          jQuery('ul.grid li.grid__item .swatches ul.swatch-view li.swatch-view-item span').each(function (index, ele) {
            let s = jQuery(this).text();
            s = s.substr(s.indexOf("(") + 1);
            s = s.replace(")", "");
            jQuery(this).text(s);
          });
        }
      }
    }
    wcInterval = setInterval(wcRenameSizeInterval, 100);
  }
  wcRenameSize();


  let observer = new MutationObserver(function (mutations) {
    jQuery('ul.grid li.grid__item .swatches ul.swatch-view li.swatch-view-item span').each(function (index, ele) {
      let s = jQuery(this).text();
      s = s.substr(s.indexOf("(") + 1);
      s = s.replace(")", "");
      jQuery(this).text(s);
    });
  });

  function wcRenameSizeObserver() {
    let found = false;
    let count = 0;
    let wcInterval;

    function wcRenameSizeObserverInterval() {
      if (!found) {
        if (jQuery('ul.grid li.grid__item .card__heading a').length) {
          clearInterval(wcInterval);
          found = true;

          let config = {
            attributes: true,
            childList: true,
            characterData: true
          };

          let headings = document.querySelectorAll('ul.grid li.grid__item .card__heading a');

          Array.from(headings).forEach(function (heading, key) {
            observer.observe(heading, config);
          });
        }
      }
    }
    wcInterval = setInterval(wcRenameSizeObserverInterval, 100);
  }
  wcRenameSizeObserver();
});
mobileOnlySlider(".topbar-menu-item ul", false, true, 1000);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
  var slider = $($slidername);
  var settings = {
    mobileFirst: true,
    dots: $dots,
    arrows: $arrows,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    prevArrow: "<button class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_1.svg?v=1675657617' /></button>",
    nextArrow: "<button class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_2.svg?v=1675658002' /></button>",
    responsive: [{
        breakpoint: $breakpoint,
        settings: "unslick"
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  };

  slider.slick(settings);

  $(window).on("resize", function () {
    if ($(window).width() > $breakpoint) {
      return;
    }
    if (!slider.hasClass("slick-initialized")) {
      return slider.slick(settings);
    }
  });
} // Mobile Only Slider


jQuery(document).on('DOMSubtreeModified', function (e) {
  if (window.location.href.indexOf('products/minibeast-x-jordan') !== -1) {
    if (e.target.id == 'candyrack-root') {
      if (jQuery('.add-to-cart-section .product-form__submit').is(':disabled')) {
        jQuery('#candyrack-root').hide();
        jQuery('body').removeClass('candyrack-body-open');
      }
    }
  }
});

jQuery('.add-to-cart-section button.product-form__submit').click(function (e) {
  if (window.location.href.indexOf('products/minibeast-x-jordan') !== -1) {
    if (!jQuery(this).is(':disabled')) {
      jQuery('#candyrack-root').show();
    }
  }
});

$(document).ready(function (params) {
  $('#shopify-section-announcement-bar').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: 'fade',
    rtl: false,
    infinite: true,
    dots: false,
    arrows: true,
    speed: 2000
  });

  $('div[data-section="product-video-slider"] .product-slider__video video').on('play', function() {
    var currentVideo = this;
    $('div[data-section="product-video-slider"] .product-slider__video video').each(function() {
      if (this !== currentVideo) {
        this.pause();
      }
    });
  });

  $('div[data-section="product-video-slider"] .product-videos__wrapper').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    infinite: false,
    dots: false,
    arrows: true,
    speed: 1500,
    lazyLoad: 'ondemand',
    prevArrow: "<button class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_1.svg?v=1675657617' /></button>",
    nextArrow: "<button class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_2.svg?v=1675658002' /></button>",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  });

  $('div[data-section="product-video-slider"] .product-videos__wrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var currentSlideVideo = $(slick.$slides[currentSlide]).find('video')[0];
    if (currentSlideVideo) {
      currentSlideVideo.pause();
    }
  });
});

$(document).ready(function () 
{
  $('.product-slider__video video:not(.playing)').click(function(e) 
  {
    if(!$(this).hasClass('playing'))
    {   
      e.preventDefault();  
      let vid = $(this);
      let v = $(this).get(0);
      $(this).find('source').each(function( index, ele ) 
      {
        let s = $(ele).data('src');
        $(ele).attr('src',s);
      });
      v.load();
      v.play(); 
      $(vid).addClass('playing');
    }
  });
});


$(document).ready(function() 
{
  function wcChangePriceText()
  {
    const selectorsCommon = [
      'ul.product-grid li .card-information .price .price-item',
      'ul.has-slider.product-grid li .price .price-item'
    ];

    $(selectorsCommon.join(', ')).each(function() 
    {
      let txt = $( this ).text().trim();
      if(txt.indexOf('$') != -1)
      {
        txt = txt.replace('.00', '');
        $(this).text(txt);
      }
    });

  }
  wcChangePriceText();

  setTimeout(() => {
      wcChangePriceText();
  }, 100);

  const commonSelectors = [
    'ul#product-grid li .custom-swatch-multi-opts li label',
    'ul#product-grid li .custom-swatch-single-opt li label',
    'ul.has-slider.product-grid li .custom-swatch-multi-opts li label',
    'ul.has-slider.product-grid li .custom-swatch-single-opt li label'
  ];


  $(commonSelectors.join(', ')).click(function(e) 
  {
    let price = $(this).closest('li.grid__item').find('.card__content .price .price-item');
    
    $(price).each(function() 
    {
      let txt = $( this ).text().trim();
      if(txt.indexOf('$') != -1)
      {
        txt = txt.replace('.00', '');
        $(this).text(txt);
      }
    });  
  });
  
  if($('body.product').length)
  {
    function wcChangePriceTextSingle()
    {
      if($('body.product .product__info-container .price .price-item').length)
      {
        $('body.product .product__info-container .price .price-item').each(function() 
        {
          let txt = $( this ).text().trim();
          if(txt.indexOf('$') != -1)
          {
            txt = txt.replace('.00', '');
            $(this).text(txt);
          }

        });
      }
    }
    wcChangePriceTextSingle();
    

    const commonSelectorsSingle = [
      'body.product .product__info-container fieldset.product-form__input label',
      'body.product .PwzrGrid-root .rio-hide-scrollbar.rio-width-fit-content > div'
    ];
  
  
    $(commonSelectorsSingle.join(', ')).click(function(e) 
    {
      const wcInterval = setInterval(wcChangePriceTextSingle, 100);
      setTimeout(function() 
      {
        clearInterval(wcInterval);
      }, 4000);
    });

  }

  if($('cart-drawer.drawer').length)
  {
    const parent = document.getElementsByClassName('drawer')[0];
    let observer = new MutationObserver((mutations)=>
    {
      let flag = true;
mutations.forEach(function(mutation)
{
  if (mutation.target.classList.contains('price')) 
  {
    flag = false;
  }
  if (mutation.target.classList.contains('product-option')) 
  {
    flag = false;
  }
  if (mutation.target.classList.contains('totals__subtotal-value')) 
  {
    flag = false;
  }
});

      

      if(flag)
      {
        wcChangePriceTextCart();
      }
      
    });
    const config = { childList: true, subtree: true  };

    observer.observe(parent,config);

    function wcChangePriceTextCart()
    {
      const commonSelectorsCart = [
        '.cart-drawer .cart-item .cart-item__details  > div.product-option',
        '.cart-drawer .cart-item td.cart-item__totals span.price'
      ];

      $(commonSelectorsCart.join(', ')).each(function( index, ele ) 
      {
        let txt = $( this ).text().trim();
        if(txt.indexOf('$') != -1)
        {
          txt = txt.replace('.00', '');
          $(this).text(txt);
        }
      });

      const total = $('.drawer__footer p.totals__subtotal-value');
      let totalTxt = total.text().trim();
      if(totalTxt.indexOf('$') != -1)
      {
        totalTxt = totalTxt.replace('.00', '');
        total.text(totalTxt);
      }
    }
  }
});

function wcStickyFooterLink()
{
  if($(window).scrollTop() > 500 )
  {
    $('.footer-link-sticky').show();
  }
  else
  {
    $('.footer-link-sticky').hide();
  }
}
$( document ).ready(function() 
{
  wcStickyFooterLink();
});
function throttle(func, delay) {
  let timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(() => {
        func.apply(this, arguments);
        timer = null;
      }, delay);
    }
  };
}
const throttledFooterLink = throttle(wcStickyFooterLink, 300);

$(window).scroll(function () {
  throttledFooterLink();
});



$(document).ready(function() 
{
    let optionsGroups = $("body.product .rio-options  > .PwzrGrid-root > .PwzrGrid-root");
    optionsGroups.length > 0 && ($(optionsGroups).each(function(index, ele) {
        optionsGroups.eq(index).addClass(`minibeast-group-${index + 1}`)
    }),
    $('.minibeast-group-2 [data-option-type="swatch"]').length && ($('.minibeast-group-1 [data-option-type="swatch"] > div').click(function() {
        console.log(" Test-1 "),
        setTimeout(function() {
            let scrollTop = $('.rio-hide-scrollbar > [aria-label="Scroll thumbnails left"]');
            scrollTop.length > 0 && scrollTop.click()
        }, 250)
    }),
    $('.minibeast-group-2 [data-option-type="swatch"] > div').click(function() {
        console.log(" Test-2 "),
        setTimeout(function() {
            let thumbImage = $(".rio-hide-scrollbar.PwzrGrid-align-items-xs-center .PwzrGrid-item:nth-child(6) div img");
            thumbImage.length > 0 && thumbImage.closest("div").click()
        }, 250)
    }),
    $('.minibeast-group-3 [data-option-type="swatch"] > div').click(function() {
        console.log(" Test-3 "),
        setTimeout(function() {
            let thumbImage = '';
            if($('.rio-hide-scrollbar.PwzrGrid-align-items-xs-center .PwzrGrid-item div img').length > 9)
            {
                thumbImage = $('.rio-hide-scrollbar.PwzrGrid-align-items-xs-center .PwzrGrid-item:nth-child(10) div img');
            }
            else
            {
                thumbImage = $('.rio-hide-scrollbar.PwzrGrid-align-items-xs-center .PwzrGrid-item:nth-child(9) div img');
            }
            thumbImage.length > 0 && thumbImage.closest("div").click()
        }, 250)
    })))
});


$(document).ready(function() {
    if ($('.product__accordion.accordion.quick-add-on').length) {
        $('.product__accordion.accordion.quick-add-on summary').click();
    }

  var value = new Date().getTimezoneOffset().toString();
  $('input[name="properties[__shopify_offset]"]').attr("value", value),
  $(".recipient__checkbox").on("click", function () {
      $(this).is(":checked") ? $(".recipient-fields").slideDown() : $(".recipient-fields").slideUp();
  });
});

$(document).ready(function(){
  $('.similar_product_main_wrapper').slick({
    infinite: false,
    speed: 500,
    slidesToShow: 4.3,
    slidesToScroll: 1,    
    prevArrow:'<svg class="custom_coll_prev_arrow" fill="#000000" width="20px" height="20px" viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g data-name="Group 132" id="Group_132"> <path d="M38,52a2,2,0,0,1-1.41-.59l-24-24a2,2,0,0,1,0-2.82l24-24a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82L16.83,26,39.41,48.59A2,2,0,0,1,38,52Z"></path> </g> </g></svg>',
    nextArrow:'<svg class="custom_coll_next_arrow" fill="#000000" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 477.175 477.175" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5 c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z "></path> </g> </g></svg>',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3.3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.3,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    }
  ]
  });
});

$(document).ready(function(){
  $.ajax({
    url: 'https://www.minibeastofficial.com/browsing_context_suggestions.json',
    method: 'get',
    datatype: 'json',
    success: function(data){
      var country_name = data.detected_values.country_name;
      if(country_name == 'United States'){
        $('.checkout-promo-bar').show();
      }else{
        $('.checkout-promo-bar').hide();
        $('body').addClass('hide_shipping_bar');
      }
    }
  });
});   


 $(document).ready(function () 
  {
    $('.custom_proudct_color_collapsible_tab .color_swatch_img p').each(function () 
    { 
      let color = $(this).text();
      color = color.replace(' - Yanre', '');
      $(this).text(color);
    });
  });


$(document).ready(function () 
{
  const eleBody = document.querySelector('body');
  if(eleBody) 
  {
    const observer = new MutationObserver((mutations) => 
    {
      if (eleBody.classList.contains('candyrack-body-open')) 
      { 
        let found = false;
        let attempts = 0;
        const maxAttempts = 10;
        const intervalTime = 250;
      
        let interval = setInterval(() => 
        {  
          if (!found) 
          {
            const element = document.querySelector('#candyrack-frame');
            if (element) 
            {
              clearInterval(interval);
              found = true;

              const scriptId = 'custom-script'; 

              const iframeHead = jQuery('#candyrack-frame').contents().find("head");

              if (iframeHead.find("#" + scriptId).length === 0) 
              {
                const script = document.createElement("script");
                script.type = "text/javascript";
                script.id = scriptId; 
                script.text = `
                function addDiscountedPrice() 
                {
                  let attempts = 0;
                  const maxAttempts = 10;
                  const intervalTime = 250;

                  const interval = setInterval(() => 
                  {
                    
                    const OfferPriceElement = document.querySelector('#modal-container .Main-Content span.Offer-Price span');
                    const OfferPriceElement2 = document.querySelector('#modal-container .Main-Content .Product-Price span');
                    if (OfferPriceElement || OfferPriceElement2) 
                    {
                      clearInterval(interval);
                      
                      applyDiscount('#modal-container .Main-Content span.Offer-Price span');
                      applyDiscount('#modal-container .Main-Content .Product-Price span');
                      
                      for (let i = 1; i <= 3; i++) {
                      setTimeout(() => 
                        {
                          applyDiscount('#modal-container .Main-Content span.Offer-Price span');
                          applyDiscount('#modal-container .Main-Content .Product-Price span');
                         }, i * 1000);
                    }

                    }

                    if (++attempts >= maxAttempts) 
                    {
                        clearInterval(interval);
                    }
                  }, intervalTime);
                }
                function applyDiscount(selector) 
                {
                  document.querySelectorAll(selector).forEach(element => 
                  {
                    let discountSpan = element.parentElement.querySelector('.discounted-price');
                    if(!discountSpan)
                    {
                      const offerPrice = parseFloat(element.textContent.replace('$', '').replace(',', '').trim());

                      if (!isNaN(offerPrice)) 
                      {
                        const discountedPrice = (offerPrice * 0.4).toFixed(2);
                        const newSpan = document.createElement('span');
              
                        newSpan.textContent = '$'+discountedPrice;
                        newSpan.className = 'discounted-price';
                        newSpan.style.cssText = "text-decoration: none; margin-left: 10px; color: #900;";
                        
                        element.parentElement.appendChild(newSpan);
                      }
                    }
                  });
                }
                addDiscountedPrice();
                `;
                iframeHead.append(script);
              }
              else
              {
                const script = document.createElement("script");
                script.type = "text/javascript";
                script.text = `
                  if (typeof addDiscountedPrice === "function") 
                  {
                    addDiscountedPrice(); 
                  }`;
                iframeHead.append(script);
              }
            }
          }
          if (attempts >= maxAttempts) 
          {
            clearInterval(interval);
          }
          attempts++;
        }, intervalTime);
      }
    });
    const config = { attributes: true };
    observer.observe(eleBody, config);
  }
});


$(document).ready(function () {
    /** check if collection page  **/
if ($('h1.collection-hero__title').length > 0) 
{
    function getSlickSettings() {
        $('.card__media').each(( index, ele )=> {
            const cardMediaHeight = $(ele).height();
            $(ele).find('.variant-images img').css({'max-height': cardMediaHeight + 'px'});
        });

        return {
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
        };
    }

        const firstVariantImages = '.card__media .variant-images:first-of-type:not(.slick-initialized)';

        /** mutation observer  **/
        const ele = document.querySelector('#ProductGridContainer');
        if (ele) {
            const observer = new MutationObserver((mutations) => {
                filterApplied();
            });

            const config = { childList: true, subtree: false };
            observer.observe(ele, config);

            function filterApplied() {
                $(firstVariantImages).slick(getSlickSettings());
            }
        }

        /** infinite scroll  **/
        const trigger = document.querySelector('#InfiniteScrollTrigger');
        if (trigger) {
            let isLoading = false;

            const loadMoreProducts = () => {
                if (isLoading) return;

                /** need to get it again here **/
                const trigger = document.querySelector('#InfiniteScrollTrigger');
                if (!trigger) return; 

                const nextUrl = trigger.getAttribute('data-next-url');
                if (!nextUrl) return;

                isLoading = true;

                const  processingImg = document.querySelector('#ProductGridContainer .processing');
                if(processingImg !== null && processingImg !== undefined )
                {
                    processingImg.style.display = 'block';
                }
                
                fetch(nextUrl)
                    .then(res => res.text())
                    .then(data => {

                        const productGrid = document.querySelector('#product-grid');
                        
                        const parser = new DOMParser();
                        const htmlDoc = parser.parseFromString(data, 'text/html');

htmlDoc.querySelectorAll('li.grid__item').forEach(el => {
    el.classList.add('wc-need-to-process');
});

                        // Append new products
                        const newHTML = htmlDoc.querySelector('#product-grid')?.innerHTML;
                        if(newHTML !== null && newHTML !== undefined  )
                        {
                            productGrid.insertAdjacentHTML('beforeend', newHTML);
                        }

                        // Update next URL
                        const newTrigger = htmlDoc.querySelector('#InfiniteScrollTrigger');
                        const newNextUrl = newTrigger?.getAttribute('data-next-url');


                        if (newNextUrl) {
                            trigger.setAttribute('data-next-url', newNextUrl);
                        }
                        else {
                            // No more pages — remove trigger so it stops loading
                            trigger.remove();
                        }

                        $(firstVariantImages).slick(getSlickSettings());

                    })
.finally(() => {
    isLoading = false;
    if (processingImg !== null && processingImg !== undefined) {
        processingImg.style.display = 'none';
    }

    $('.wc-need-to-process .product_tile_color_holder .label-active').click();
    setTimeout(() => {
        $('.wc-need-to-process').removeClass('wc-need-to-process');
        $( "#product-grid li.grid__item" ).each(function( index, ele ) 
        {
            let variantSelector ='.all-variants-wrapper span';

            let selctedColor =  $(ele).find('.product_tile_color_holder label.label-active')?.attr('data-option-value');
            if(selctedColor)
            {
                variantSelector += `[data-option1="${selctedColor}"]`

                $(ele).addClass(`wc-color-${selctedColor}`);
                selctedColor = '.variant-images-'+selctedColor?.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-');

                const $slickWithWrongColor = $(ele).find(`.card__media .slick-initialized:not(${selctedColor})`); 
                if($slickWithWrongColor.length > 0)
                {
                    $slickWithWrongColor.slick('unslick');
                }   
            }

            const selctedSize =  $(ele).find('.product_tile_size_holder li label.label-active')?.attr('data-option-value');
            if(selctedSize)
            {
                $(ele).addClass(`wc-size-${selctedSize}`);
                variantSelector += `[data-option2="${selctedSize}"]`
            }

            $( $(ele).find(variantSelector) ).each(function( index2, ele2 ) 
            {
                const avail = $(ele2).attr('data-variant-available');
                if(avail)
                {
                    const url = $(ele2).attr('data-variant-url');
                    $(ele).find('.card__inner .variant-images.slick-initialized .variant-image a').attr('href',url);
                    $(ele).find('.card.card--media > .card__content .card__heading a').attr('href',url);
                }
            });
        });
    }, 500);
});
            };

            const handleScroll = () => {

                /** need to get it again here **/
                const trigger = document.querySelector('#InfiniteScrollTrigger');
                if (!trigger) return;

                const triggerTop = trigger.getBoundingClientRect().top;
                const viewportHeight = window.innerHeight;

                // When trigger is visible or ~350px above bottom
                if (triggerTop < viewportHeight + 350) {

                    loadMoreProducts();
                }
            };

            function throttle(func, delay) {
                let timer = null;
                return function (...args) {
                    if (!timer) {
                        timer = setTimeout(() => {
                            func.apply(this, args);
                            timer = null;
                        }, delay);
                    }
                };
            }

            const throttledScrollHandler = throttle(handleScroll, 500);
            window.addEventListener('scroll', throttledScrollHandler);
        }
    }
});


$(document).ready(function () 
{
    if($(window).width() > 767)
    {
        let found = false;
        let attempts = 0;
        const maxAttempts = 10;
        const intervalTime = 500;
        let interval = setInterval(() => 
        {
            if (!found) 
            {
                const ele = document.querySelector('.rio-media-gallery .rio-hide-scrollbar .rio-hide-scrollbar');
                if (ele) 
                {
                    clearInterval(ele);
                    found = true;
                    enableMutationObserver(ele);                
                }
            }
            if (attempts >= maxAttempts) 
            {
                clearInterval(interval);
            }
            attempts++;
        }, intervalTime);

        function enableMutationObserver(ele) 
        {
            const observer = new MutationObserver((mutations) => 
            {
                addSwiperArrows();
            });
            const config = {  childList: true, subtree: false };
            observer.observe(ele, config);

            function addSwiperArrows() 
            {
                $('.pwzrswiper-container').append('<button class="pwzrswiper-arrow pwzrswiper-prev hide"></button><button class="pwzrswiper-arrow pwzrswiper-next"></button>');
            }
            addSwiperArrows();

            $(document).on('click','.pwzrswiper-arrow',function(e) 
            {
                e.preventDefault();
                let $currentItem = null;
                const activeImg =  $('#pwzrswiper-wrapper').find('.pwzrswiper-slide-active img').attr('src');
                const activeImgName = activeImg.split('/').pop().split('?')[0];
                $('.rio-hide-scrollbar.PwzrGrid-container .PwzrGrid-item').each(( index, ele )=> {
                    const imgSrc = $(ele).find('img').attr('src');
                    if(imgSrc)
                    {
                        const imgName = imgSrc.split('/').pop().split('?')[0];
                        if(imgName == activeImgName )
                        {
                            $currentItem = $(ele);
                        }
                    } 
                });

                if($currentItem)
                {
                    let $newItem = null;
                    $('button.pwzrswiper-arrow').removeClass('hide');
                    if($(this).hasClass('pwzrswiper-prev'))
                    {
                        $newItem = $currentItem.prev('.PwzrGrid-item');
                        const nextPrev = $newItem.prev('.PwzrGrid-item');
                        if(nextPrev && nextPrev.length < 1)
                        {
                            $('button.pwzrswiper-prev').addClass('hide')
                        }
                    }
                    else
                    {
                        $newItem = $currentItem.next('.PwzrGrid-item');
                        const nextNext = $newItem.next('.PwzrGrid-item');
                        if(nextNext && nextNext.length < 1)
                        {
                            $('button.pwzrswiper-next').addClass('hide')
                        }
                    }
                    if($newItem && $newItem.length > 0)
                    {
                        $newItem.find('div').click();
                    }
                }
            });
        }
    }
});


$(document).ready(function () {
    setTimeout(() => {
        $( "#product-grid li.grid__item" ).each(function( index, ele ) 
        {
            $gridItem = $(ele);
            wcUpdateURL($gridItem);
        });
    }, 1000);
});


$(document).on('click','.custom-swatch-multi-opts .product_tile_color_holder ul li label',function(e) 
{
    setTimeout(() => {
        $gridItem = $(this).closest('li.grid__item');
        wcUpdateURL($gridItem);
    }, 500);
    
});

$(document).on('click','.custom-swatch-multi-opts .product_tile_size_holder ul li label',function(e) 
{
    setTimeout(() => {
        $gridItem = $(this).closest('li.grid__item');
        wcUpdateURL($gridItem);
    }, 500);
});

function wcUpdateURL($gridItem)
{
    let variantSelector ='.all-variants-wrapper span';

    let selctedColor =  $gridItem.find('.product_tile_color_holder label.label-active')?.attr('data-option-value');
    if(selctedColor)
    {
        variantSelector += `[data-option1="${selctedColor}"]`
    }


    const selctedSize =  $gridItem.find('.product_tile_size_holder li label.label-active')?.attr('data-option-value');
    if(selctedSize)
    {
        variantSelector += `[data-option2="${selctedSize}"]`
    }

    $( $gridItem.find(variantSelector) ).each(function( index2, ele2 ) 
    {
        const avail = $(ele2).attr('data-variant-available');

        if(avail)
        {
            const url = $(ele2).attr('data-variant-url');

            $gridItem.find('.card__inner .variant-images.slick-initialized .variant-image a').attr('href',url);
            $gridItem.find('.card.card--media > .card__content .card__heading a').attr('href',url);
        }
    });
}

$(document).ready(function () {
    $('.wc-blog-slider ul.blog__posts').slick({
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipe: false,
        prevArrow: "<button class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_1.svg?v=1675657617' /></button>",
        nextArrow: "<button class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0086/8499/4615/files/Vector_2.svg?v=1675658002' /></button>",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    swipe: true,
                }
            }
        ]
    });
});

$(document).ready(function () {
    $('.popup_icon').on('click', function () {
        const $popup = $(this).closest('.multicolumn-block-item').find('.popup-overlay');
        const $video = $popup.find('video')[0];
        $popup.fadeIn();
        $video.play();
        $video.muted = false;
        $('body').addClass('no-scroll');
    });
    $('.close-popup').on('click', function () {
        close();
    });
    $('.popup-overlay').on('click', function (e) {
        if ($(e.target).is('.popup-overlay')) {
            close();
        }
    });
    function close() {
        $('body').removeClass('no-scroll');
        $('.popup-overlay').fadeOut();
        $('.popup-overlay video').each(function () {
            this.pause();
            this.currentTime = 0;
        });
    }
});



